<template>
  <sui-modal class="wrapper" v-model="visible" size="small" :closable="false" :style="{zIndex}">
    <sui-modal-header class="header">
      Create role
    </sui-modal-header>
    <sui-modal-content>
      <sui-form warning :error="hasApiErrors" :loading="loading" @submit.prevent="submit()" v-if="entity">
        <sui-form-field>
          <FormRole v-model="entity" mode="creating" />
        </sui-form-field>
        <sui-message error>
          {{apiErrors}}
        </sui-message>
      </sui-form>
    </sui-modal-content>
    <sui-modal-actions>
      <div class="ui buttons">
        <sui-button icon="check" label-position="left" color="green" :disabled="loading || hasEntityErrors" @click="submit()" data-goal="CREATE_ROLE_TRY">Confirm</sui-button>
        <sui-button icon="ban" label-position="right" color="red" @click="cancel()">Cancel</sui-button>
      </div>
    </sui-modal-actions>
    <sui-dimmer class="dimmer" :active="success" inverted>
      <h2 class="ui icon header">
        <i class="green check circle icon" />
        Success
      </h2>
    </sui-dimmer>
  </sui-modal>
</template>

<script>
  import ModalForm from '@/mixins/ModalForm'
  import FormRole from '@/components/forms/Role'
  import utils from '@/utils'

  export default {
    name: 'ModalCreateRole',
    mixins: [
      ModalForm,
    ],
    components: {
      FormRole,
    },
    methods: {
      open(entity = {}) {
        this.visible = true
        this.entity = {
          ...entity,
          name: entity.name || utils.generateName(),
        }
      },
      onSuccess() {
        this.close()
        utils.reachGoal('CREATE_ROLE_SUCCESS')
      },
      onFail() {
        utils.reachGoal('CREATE_ROLE_FAIL')
      },
    },
    created() {
      this.$modals.createRole = this
    },
  }
</script>
